import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";

import * as AppActions from "../../reducers/appReducer";
import Card from "../structure/Card";
import { error, success } from "../structure/Alert";
import { BillingAPI } from "../../api/index";
import format from "../../utils/currency";

interface IManagePlansScreenState {
  loading: boolean;
  platform: string;
  plans: IPlan[];
  currentPlan: IPlan;
  newPlan: boolean;
  deviceType: string;
}

interface IManagePlansScreenProps {
  appUsersDevicesState: any;
  userState: any;
  appState: any;
}

interface IPlan {
  id: number;
  display: string;
  amount: number;
  currency: string;
  description: string;
  deviceType: string;
  freeDays: number;
  platform: string;
  service: string;
  showPlan: boolean;
  term: string;
  features?: IFeatures;
}


interface IFeatures {
  planId: number;
  cellData?: boolean;
  streaming?: boolean;
  videoRecording?: boolean;
  images?: boolean;
  streamOverCell?: boolean;
}

const blankFeatures: IFeatures = {
  planId: 0,
  cellData: false,
  streaming: false,
  videoRecording: false,
  images: false,
  streamOverCell: false
};

const blankPlan: IPlan = {
  id: 0,
  display: "",
  amount: 0,
  currency: "usd",
  description: "",
  deviceType: "collar",
  freeDays: 0,
  platform: "",
  service: "",
  showPlan: false,
  term: "free",
  features: blankFeatures,
};

class ManagePlansScreen extends React.Component<IManagePlansScreenProps, IManagePlansScreenState> {

  constructor(props: IManagePlansScreenProps) {
    super(props);
    this.state = {
      loading: false,
      platform: "wagz2",
      plans: [],
      currentPlan: blankPlan,
      newPlan: true,
      deviceType: "collar"
    };

    this.updateField = this.updateField.bind(this);
    this.send = this.send.bind(this);
    this.fetchPlans = this.fetchPlans.bind(this);
    this.createNewPlan = this.createNewPlan.bind(this);
    this.updatePlanField = this.updatePlanField.bind(this);
    this.updateFeatureField = this.updateFeatureField.bind(this);
    this.getFeaturesForm = this.getFeaturesForm.bind(this);
    this.featchFeaturesForPlan = this.featchFeaturesForPlan.bind(this);
  }

  public componentDidMount() {
    this.fetchPlans();
  }

  public render() {
    let loading = this.state.loading;
    if (!this.props.appUsersDevicesState[this.props.appState.app]) {
      loading = true;
    }
    return (
      <div className="row">
        <div className="col-md-3">
          <Card title="Select Event" loading={loading}>
            <div className="form-group">
              <p><strong>Select a platform and plan, or choose to add a new plan</strong></p>
            </div>
            <div className="form-group">
              <label>Platform</label>
              <select className="form-control" id="platform" value={this.state.platform} onChange={this.updateField}>
                <option value="wagz2">Wagz</option>
                <option value="bd">Black + Decker</option>
                <option value="petzi" disabled={true}>Petzi (Coming soon!)</option>
              </select>
            </div>
            <div className="form-group">
              <label>Device Type</label>
              <select className="form-control" id="deviceType" value={this.state.deviceType} onChange={this.updateField}>
                <option value="collar">Collar</option>
                <option value="door">Door</option>
                <option value="feeder">Feeder</option>
                <option value="pendant">Pendant</option>
                <option value="tile">Tile</option>
                <option value="treatCam">Treatcam</option>
              </select>
            </div>
            <div className="form-group">
              <label>Plans</label>
              <select className="form-control" id="selectedPlan" onChange={this.updateField} value={this.state.currentPlan.id}>
                <option key={0} value={0}>SELECT A PLAN</option>
                {this.state.plans.map((plan: IPlan) => {
                  return (<option key={plan.id} value={plan.id}>{plan.display} - {plan.term} {format(plan.amount)}</option>);
                })}
              </select>
            </div>
            <div className="form-group">
              <button className="btn btn-block btn-primary" onClick={this.createNewPlan}>Create New Plan</button>
            </div>
          </Card>
        </div>


        <div className="col-md-5">
          <Card title="Manage Event" loading={loading}>
            <div className="form-group">
              <label>Display Title</label>
              <p className="small">This is the primary display for the event</p>
              <input type="text" id="display" className="form-control" value={this.state.currentPlan.display} onChange={this.updatePlanField} />
            </div>
            <div className="form-group">
              <label>Description</label>
              <p className="small">This is the primary description and will be displayed in smaller text.</p>
              <textarea id="description" className="form-control" value={this.state.currentPlan.description} onChange={this.updatePlanField} rows={3} />
            </div>
            <div className="form-group">
              <label>Amount</label>
              <p className="small">How much are you charging <strong>IN PENNIES.</strong></p>
              <input type="number" id="amount" className="form-control" value={this.state.currentPlan.amount} onChange={this.updatePlanField} />
            </div>
            <div className="form-group">
              <label>Term</label>
              <select id="term" className="form-control" value={this.state.currentPlan.term} onChange={this.updatePlanField}>
                <option value="free">Free</option>
                <option value="monthly">Monthly</option>
                <option value="annual">Annual</option>
                <option value="24months">Every 24 Months</option>
              </select>
            </div>
            <div className="form-group">
              <label>Free Trial Days</label>
              <p className="small">Only applicable from time since registration.</p>
              <input type="number" id="freeDays" className="form-control" value={this.state.currentPlan.freeDays} onChange={this.updatePlanField} />
            </div>
            <div className="form-group">
              <label>Show Plan</label>
              <p className="small">Whether or not the plan should show in the mobile apps.</p>
              <select id="showPlan" className="form-control" value={this.state.currentPlan.showPlan + ""} onChange={this.updatePlanField}>
                <option value="false">False</option>
                <option value="true">True</option>
              </select>
            </div>
            <div className="form-group">
              <p className="small"><strong>Please be aware that this will be effective immediately and users on this plan will receive the new information, including having their charges updated to reflect any new data!</strong></p>
              <button className="btn btn-block btn-success" onClick={this.send}>Save Plan</button>
            </div>
          </Card>
        </div>

        {this.getFeaturesForm()}

      </div>
    );
  }


  private updateField(e: any) {
    const id = e.target.id;
    const ns: IManagePlansScreenState = this.state;
    const value = e.target.value;
    ns[id] = value;

    if (id === "platform") {
      this.setState({
        ...ns,
        currentPlan: blankPlan
      }, () => { this.fetchPlans(); });
    } else if (id === "deviceType") {
      const newState = {
        ...ns,
        currentPlan: {
          ...blankPlan,
          deviceType: value
        }
      };
      this.setState(newState, () => { this.fetchPlans(); });
    } else if (id === "selectedPlan") {
      // populate some additional fields
      let foundPlan: IPlan = blankPlan;
      for (const plan of this.state.plans) {
        if (plan.id === parseInt(value, 10)) {
          foundPlan = plan;
        }
      }
      if (foundPlan.id !== 0) {
        ns.currentPlan = foundPlan;
        ns.newPlan = false;
      } else {
        ns.currentPlan = blankPlan;
        ns.newPlan = true;
      }
    }
    this.setState(ns, () => {
      if (id === "deviceType" || id === "platform") {
        this.fetchPlans();
      } else if(id ==="selectedPlan"){
        // we need to get the features
        this.featchFeaturesForPlan();
      }
    });
  }



  private updatePlanField(e: any) {
    const currentPlan: IPlan = this.state.currentPlan;
    // parse it; since booleans aren't valid for selects, and numbers turn into strings, parse
    if (e.target.id === "amount" || e.target.id === "freeDays") {
      e.target.value = parseInt(e.target.value, 10);
    } else if (e.target.id === "showPlan") {
      e.target.value = e.target.value === "true" ? true : false;
    }
    currentPlan[e.target.id] = e.target.value;
    this.setState({ currentPlan });
  }

  private updateFeatureField(e: any) {
    const data = this.state.currentPlan.features ? this.state.currentPlan.features : blankFeatures;
    data[e.target.id] = e.target.value;
    const plan = this.state.currentPlan;
    plan.features = data;
    this.setState({
      currentPlan: plan
    });
  }

  /**
   * This is pretty complex, as we need to show and hide certain fields depending on the device type
   */
  private getFeaturesForm() {
    const dt = this.state.deviceType;
    if (dt === "tile" || dt === "pendant" || dt === "treatcam") {
      return (<div className="col-md-4">
        <Card title="Manage Feature Flags" loading={this.state.loading}>
          <strong>Feature flags are only supported for doors, feeders, and collars at this time</strong>
        </Card>
      </div>);
    }
    return (
      <div className="col-md-4">
        <Card title="Manage Feature Flags" loading={this.state.loading}>
          <div className="form-group">
            <label>Allow Streaming</label>
            <p className="small">Are they allowed to stream audio and video, as applicable?</p>
            <select id="streaming" className="form-control" 
              value={this.state.currentPlan.features && this.state.currentPlan.features.streaming !== undefined ? 
                this.state.currentPlan.features.streaming + "" : 
                "false"} onChange={this.updateFeatureField}>
              <option value="false">False</option>
              <option value="true">True</option>
            </select>
          </div>
          {dt !== "collar" ? null : (
            <div className="form-group">
              <label>Allow Cellular Data Usage</label>
              <p className="small">If the SIM is activated, are they allowed to use data over the cellular system?</p>
              <select id="cellData" className="form-control" 
                value={this.state.currentPlan.features && this.state.currentPlan.features.cellData !== undefined ? 
                  this.state.currentPlan.features.cellData + "" : 
                  "false"} onChange={this.updateFeatureField}>
                <option value="false">False</option>
                <option value="true">True</option>
              </select>
            </div>
          )}
          {dt !== "collar" ? null : (
            <div className="form-group">
              <label>Allow Streaming Over Cellular Data</label>
              <p className="small">If data over cellular is allowed, can they stream video as well?</p>
              <select id="streamOverCell" className="form-control" 
                value={this.state.currentPlan.features && this.state.currentPlan.features.streamOverCell !== undefined ? 
                  this.state.currentPlan.features.streamOverCell + "" : 
                  "false"} onChange={this.updateFeatureField}>
                <option value="false">False</option>
                <option value="true">True</option>
              </select>
            </div>
          )}
          <div className="form-group">
            <label>Allow Video Recording</label>
            <p className="small">Can they record and save videos?</p>
            <select id="videoRecording" className="form-control" 
              value={this.state.currentPlan.features && this.state.currentPlan.features.videoRecording !== undefined ? 
                this.state.currentPlan.features.videoRecording + "" : 
                "false"} onChange={this.updateFeatureField}>
              <option value="false">False</option>
              <option value="true">True</option>
            </select>
          </div>
          <div className="form-group">
            <label>Allow Image Saving</label>
            <p className="small">Allows video or audio streaming</p>
            <select id="images" className="form-control" 
              value={this.state.currentPlan.features && this.state.currentPlan.features.images !== undefined ? 
                this.state.currentPlan.features.images + "" : 
                "false"} onChange={this.updateFeatureField}>
              <option value="false">False</option>
              <option value="true">True</option>
            </select>
          </div>
        </Card>
      </div>
    );
  }

  private async send() {
    // implement
    if (this.state.currentPlan.description === "" || this.state.currentPlan.display === "") {
      return error("Display and Description should not be blank!");
    }
    this.setState({ loading: true }, async () => {
      try {
        // now, is it an update or a create?
        if (this.state.currentPlan.id === 0) {
          // create
          const data = this.state.currentPlan;
          data.platform = this.state.platform;
          data.service = this.state.platform;
          data.deviceType = this.state.deviceType;
          const res = await BillingAPI.createPlan(this.state.platform, data);
          this.state.currentPlan.id = res.body.data.id;
        } else {
          // update
          await BillingAPI.editPlan(this.state.platform, this.state.currentPlan.id, this.state.currentPlan);
        }
        // now save the features
        await BillingAPI.saveFeaturesForPlan(this.state.platform, this.state.currentPlan.id, this.state.currentPlan.features);
        success("Plan saved!");
        return this.fetchPlans();
      } catch (err) {
        return this.setState({
          loading: false
        }, () => {
          error("We could not save that plan");
        });
      }
    });
  }

  private async fetchPlans() {
    this.setState({ loading: true }, async () => {
      try {
        const res = await BillingAPI.getPlans(this.state.platform, { deviceType: this.state.deviceType });
        const plans = res.body.data;
        this.setState({
          loading: false,
          plans
        });
      } catch (err) {
        error("Could not fetch plans!");
        this.setState({
          loading: false
        });
      }
    });
  }

  private async featchFeaturesForPlan() {
    this.setState({ loading: true }, async () => {
      try {
        const res = await BillingAPI.getFeaturesForPlan(this.state.platform, this.state.currentPlan.id);
        const currentPlan = this.state.currentPlan;
        currentPlan.features = res.body.data;
        this.setState({
          loading: false,
          currentPlan
        });
      } catch (err) {
        error("Could not fetch features for that plan!");
        this.setState({
          loading: false
        });
      }
    });
  }

  private createNewPlan() {
    this.setState({
      newPlan: true,
      currentPlan: blankPlan
    });
  }
}

const mapStateToProps = function map(s: any) {
  return {
    appState: s.appState,
    appUsersDevicesState: s.appUsersDevicesState
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(AppActions, dispatch),
  };
}

export default withRouter(connect<{}, {}, any>(mapStateToProps, mapDispatchToProps)(ManagePlansScreen));


// WEBPACK FOOTER //
// ./src/components/Billing/ManagePlans.tsx